module.exports = require("core-js/library/fn/symbol/iterator");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/symbol/iterator.js